<template>
  <label
    class="flex items-center mb-0 border-gray-300 cursor-pointer v-radio-item gap-2 focus_outline-none"
    :class="[size === 'sm' ? 'px-4 py-2' : 'p-4']"
  >
    <input
      class="flex-shrink-0 w-4 h-4 border border-gray-300 rounded-full appearance-none cursor-pointer focus_ring"
      type="radio"
      :name="name"
      :value="value"
      :class="[
        `v-radio-input--${theme}`,
        {
          selected: selected,
          'not-selected': !selected,
          'border-red-500 hover_border-red-500 focus_ring-red-600': error,
          'no-error': !error,
        },
      ]"
      :aria-labelledby="`${name}-${value}-label`"
      :aria-describedby="`${name}-${value}-description`"
      :checked="selected"
      @change="$emit('input', value)"
    />

    <slot />
  </label>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'

defineProps({
  name: {
    type: String,
    required: true,
  },
  value: {
    type: [String, Number],
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  selected: {
    type: Boolean,
    default: false,
  },
  error: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'md',
  },
  theme: {
    type: String as PropType<'copper' | 'dark'>,
    default: 'copper',
  },
})

defineEmits(['input'])
</script>

<style lang="stylus" scoped>
.v-radio-input
  &--copper
    &[type=radio]:checked,
    &[type=radio]:hover
      background-image url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='3'/%3e%3c/svg%3e")

    &.selected
      @apply bg-copper-700 border-copper-700

    &.not-selected
      @apply hover_bg-gray-200 hover_border-gray-200

    &.no-error
      @apply focus_ring-copper-600

  &--dark
    &[type=radio]:checked,
    &[type=radio]:hover
      background-image url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='black' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='3'/%3e%3c/svg%3e")
    &.no-error
      @apply bg-gray-900

    &.selected
      @apply bg-copper-200 border-copper-200
</style>
